module.exports = __webpack_public_path__ + "static/media/copied.8ca1007f.svg";